// de_pms_housekeeping.ts
// Tłumaczenia dla PMS.Housekeeping.tsx

export const dePmsHousekeeping = {

  title: "Housekeeping",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    roomControl:   "Zimmerkontrolle",
    roomSnapshot:  "Zimmerstatus",
    tasks:         "Housekeeping-Aufgaben",
    maintenance:   "Wartung und Sperrung",
    realtimeFeed:  "Live-Feed",
    operations:    "Operationen",
  },

  // ── Opisy sekcji ─────────────────────────────────────────────────────────
  descriptions: {
    roomReadiness: "Zimmerbereitschaft, Aufgabenverwaltung, Wartung, Sperrung und Echtzeitbetrieb.",
    fastUpdates:   "Schnelle Zimmerstatus-Updates mit sicherer Persistenz.",
    currentState:  "Aktueller Betriebszustand.",
    createTrack:   "Betriebliche Zimmeraufgaben erstellen und verfolgen.",
    escalate:      "Technische Stoerungen eskalieren und Bestand schuetzen.",
    prepared:      "Vorbereitet fuer kuenftiges Event-Streaming auf Mitarbeitergeraeten.",
  },

  // ── Typy zadań ────────────────────────────────────────────────────────────
  taskTypes: {
    inspection:       "Inspektion",
    turndown:         "Turndown",
    deepClean:        "Grundreinigung",
    maintenanceFollowUp: "Wartungsnachkontrolle",
    taskType:         "Aufgabentyp",
  },

  // ── Statusy pokoi (specyficzne dla HK) ───────────────────────────────────
  roomStatus: {
    clean:     "Sauber",
    dirty:     "Schmutzig",
    cleaning:  "In Reinigung",
    inspected: "Geprueft",
    blocked:   "Gesperrt",
  },

  // ── Konserwacja i blokowanie ──────────────────────────────────────────────
  maintenance: {
    severity:    "Stoerungs-Schweregrad",
    blockRoom:   "Zimmer sperren",
    releaseBlock:"Sperre aufheben",
    resolved:    "Vom Service behoben, an Housekeeping uebergeben.",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    priority:          "Prioritaet",
    housekeepingStatus:"Housekeeping-Status",
    unassigned:        "Nicht zugewiesen",
  },

  // ── Komunikaty błędów ─────────────────────────────────────────────────────
  messages: {
    blockFailed:            "Zimmersperre fehlgeschlagen.",
    blockReleaseFailed:     "Aufhebung der Sperre fehlgeschlagen.",
    maintenanceReportFailed:"Wartungsmeldung fehlgeschlagen.",
    maintenanceUpdateFailed:"Wartungsaktualisierung fehlgeschlagen.",
    roomUpdateFailed:       "Zimmeraktualisierung fehlgeschlagen.",
    taskCreationFailed:     "Aufgabenerstellung fehlgeschlagen.",
    taskUpdateFailed:       "Aufgabenaktualisierung fehlgeschlagen.",
  },

} as const;

export default dePmsHousekeeping;
